import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Globals } from '../../../global';

@Component({
  selector: 'app-basic-login',
  templateUrl: './basic-login.component.html',
  styleUrls: ['./basic-login.component.scss']
})
export class BasicLoginComponent implements OnInit {

	active = false;
	showPassword: boolean = false;
	error = false;
	errorMessage = "Ha ocurrido un error al iniciar sesión";
	year = Date();

  constructor(private router: Router, private authService: AuthService, private globals: Globals) { }

	login(email, password) {
		if (email === "" || password === "") {
			this.error = true;
		} else {
			const body = {
				email: email,
				password: password
			}
			
			this.authService.login(body)
				.subscribe((response: any) => {
					console.log(response);
					if (response.success === true) {
						localStorage.setItem('user', JSON.stringify(response));
						localStorage.setItem('urlAudio', response.data.soundNotification);
						this.authService.setToken(response.token);
						this.router.navigateByUrl('/dashboard');
					} else {
						this.errorMessage = 'Correo o Contraseña incorrectos';
					}
				},
				error => {
					console.log(error.error.message);
					this.errorMessage = error.error.message;
					this.error = true;
				})
		}
	}

  ngOnInit() {
    document.querySelector('body').setAttribute('themebg-pattern', 'theme1');
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/login/basic-login/basic-login.component.ts